import { AvvirEvent } from "type_aliases";

export type UserInvitationGeneratedEvent = AvvirEvent<typeof USER_INVITATION_GENERATED, { organizationId: string, link: string }>

const userInvitationGenerated = (organizationId: string, link: string): UserInvitationGeneratedEvent => ({
  type: USER_INVITATION_GENERATED,
  payload: {
    organizationId,
    link
  }
});

export const USER_INVITATION_GENERATED = "user_invitation_generated";

export default userInvitationGenerated;
